<template>
  <div class="gauge">
    <img src="@/assets/images/icons/gauge.svg" alt="" />
    <img
      src="@/assets/images/icons/gaugeMeter.svg"
      class="meter"
      :style="{ transform: `scale(1.435) rotate(${rotation}deg)` }"
      alt=""
    />
    <svg
      :viewBox="`0 0 ${size} ${size / 2 + 40}`"
      style="overflow: visible"
      class="meter-label"
    >
      <g v-for="(pct, i) in percentTicks" :key="i">
        <text
          :x="tickCoords[i].x"
          :y="tickCoords[i].y - 5"
          text-anchor="middle"
          font-size="10"
          fill="#111"
        >
          {{ pct }}%
        </text>
      </g>
    </svg>
    <div class="text-box">
      Available Credit Limit
      <h3>{{ available }}</h3>
    </div>
    <div class="gauge-label">{{ max }}</div>
    <div class="gauge-label-2">Uses Credit: {{ max - available }}</div>
  </div>
</template>

<script>
export default {
  name: "Gauge",
  props: {
    max: { type: Number, required: true }, // e.g. 20
    available: { type: Number, required: true }, // e.g. 15
    size: { type: Number, default: 200 }, // overall SVG width
    arcWidth: { type: Number, default: 14 }, // thickness of the arcs
  },
  computed: {
    centerX() {
      return this.size / 2;
    },
    centerY() {
      return this.size / 2;
    },

    radius() {
      return this.size / 2;
    },

    rotation() {
      return this.lerp(
        -(360 - 237),
        85,
        (this.max - this.available) / this.max
      );
    },
    segments() {
      const cuts = [0.5, 0.75, 1];
      const colors = ["#4caf50", "#ffb74d", "#e57373"];
      let last = 0;
      return cuts.map((t, i) => {
        const startA = 180 + last * 180;
        const endA = 180 + t * 180;
        last = t;
        return {
          color: colors[i],
          path: this.describeArc(
            this.centerX,
            this.centerY,
            this.radius,
            startA,
            endA
          ),
        };
      });
    },

    percentTicks() {
      return [0, 25, 50, 75, 100];
    },
    tickValues() {
      return this.percentTicks.map((p) =>
        Math.round((p / 100) * this.capLimit)
      );
    },
    tickCoords() {
      const r = this.radius + 36;
      return this.percentTicks.map((p) => {
        const θ = ((200 - (p / 100) * 220) * Math.PI) / 180;
        return {
          x: this.centerX + r * Math.cos(θ),
          y: this.centerY - r * Math.sin(θ),
        };
      });
    },

    percent() {
      return Math.min(1, this.consumed / this.capLimit);
    },

    needleAngle() {
      return 180 + this.percent * 180;
    },
    needleLength() {
      return this.radius;
    },
    needleBase() {
      return this.arcWidth / 2;
    },
    needlePath() {
      const cx = this.centerX,
        cy = this.centerY,
        b = this.needleBase,
        L = this.needleLength;
      return `M ${cx},${cy - b} L ${cx},${cy + b} L ${cx + L},${cy} Z`;
    },

    pivotR() {
      return this.arcWidth / 2;
    },
  },

  methods: {
    polarToCartesian(cx, cy, r, angleDeg) {
      const rad = (angleDeg * Math.PI) / 180;
      return {
        x: cx + r * Math.cos(rad),
        y: cy + r * Math.sin(rad),
      };
    },
    lerp(start, end, t) {
      return start * (1 - t) + end * t;
    },

    describeArc(cx, cy, r, startAngle, endAngle) {
      const start = this.polarToCartesian(cx, cy, r, startAngle);
      const end = this.polarToCartesian(cx, cy, r, endAngle);
      return ["M", start.x, start.y, "A", r, r, 0, 0, 1, end.x, end.y].join(
        " "
      );
    },
  },
};
</script>

<style scoped>
.gauge {
  display: inline-block;
  text-align: center;
  overflow: none;
  position: relative;
  margin: 20px;
  margin-bottom: 120px;
}
.gauge-label {
  margin-top: -50px;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  /* display: none; */
}
.gauge-label-2 {
  position: absolute;
  bottom: -64%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 550;
}
.meter {
  position: absolute;
  left: 0;
  top: 30%;

  transform-origin: 50% 60%;
  width: 100%;
  height: 100%;
}
.meter-label {
  position: absolute;
  left: 0;
  top: 21%;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.text-box {
  position: absolute;
  left: 50%;
  top: 70%;
  transform: translateX(-50%);
  width: 100px;
  height: 200px;
  z-index: 5;
}
</style>
